import React from 'react'

import useStyles from './styles'

const QueueSkeleton = () => {
  const classes = useStyles()

  return (
    <div className={classes.holder}>
      <div className={classes.root}>
        <div className={classes.type} />

        <div className={classes.avatarHolder}>
          <div className={classes.avatar} />
        </div>

        <div className={classes.contentHolder}>
          <div className={classes.content} />
        </div>
      </div>
    </div>
  )
}

export default QueueSkeleton
